import styled from "styled-components";

export const Container = styled.div `
    position: relative;
    margin-top: 30px;

    @media (max-width: 800px) {  
        margin-top: 15px;
    }
    
`

export const Main = styled.main `

    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 10px;

    .season {
        padding: 10px;
        border-radius: 5px;
        background: #252525;
        border: none;
        color: #fff;
        cursor: pointer;
        transition: all .3s ease;
    }

    .season:hover {
        background: #353535;
    }

    .season img {
        max-height: 100%;
        max-width: 100%;
        border-radius: 5px;
        margin-bottom: 10px;
        aspect-ratio: 2/3;
        background: #353535;
    }

    .season header {
        display: flex;
        justify-content: space-between;
        width: 100%;
        padding: 5px 2px;
        font-weight: 600;
        color: #fff;
        text-transform: uppercase;
    }

    .season main {
        display: flex;
        padding: 5px 2px;
    }
    
    .season main span {
        position: relative;
        margin-right: 15px;
        font-weight: 600;
        font-size: .8rem;
        color: #ccc;
    }

    @media (max-width: 1200px) {
        grid-template-columns: repeat(4, 1fr);
    }

    @media (max-width: 800px) {
        grid-template-columns: repeat(3, 1fr);
    }

    @media (max-width: 500px) {
        grid-template-columns: repeat(2, 1fr);
    }

    @media (max-width: 350px) {
        grid-template-columns: repeat(1, 1fr);
    }
`

export const Message = styled.div`
    margin-bottom: 15px;
    font-size: 16px;
    color: #fff;
    background:#b50101;
    padding: 10px;
    border-radius: 5px;
    text-align: center;

    svg {
        margin-right: 5px;
    }

    h4 {
        font-size: 1rem;
        margin-bottom: 5px;
    }

    span {
        font-weight: 500;
        font-size: .8rem;
    }

    @media (max-width: 600px) {
        font-size: .7rem;
    }
`;